// extracted by mini-css-extract-plugin
module.exports = {"summaryBottom--visible":"summaryBottom--visible","summaryBottom--invisible":"summaryBottom--invisible","summaryBottom__text":"summaryBottom__text"};